// extracted by mini-css-extract-plugin
export var filterIncDec = "_an-0";
export var leftBorder = "_an-1";
export var rightBorder = "_an-2";
export var stringInput = "_an-3";